"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
require("../../../src/ui/tabs/tabs.module.scss");
const _excluded = ["active", "children", "className", "size", "onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const Tabs = exports.Tabs = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      active,
      children,
      className,
      size,
      onChange
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  className = (0, _utils.ClassNames)('kui-tabs', size ? 'kui-tabs--size_' + size : null, className);
  let [focusIndex, setFocusIndex] = React.useState(active);
  const activeRef = React.useRef(null);
  const _tabsRef = React.useRef(null);
  const tabsRef = (0, _utils.useCombinedRefs)(ref, _tabsRef);
  let childrenArray =
  // children could be string, we need array
  Array.isArray(children) ? children : [children];
  const buttonHocs = React.Children.map(childrenArray, (child, i) => {
    if (!child) return null;
    return /*#__PURE__*/React.cloneElement(child, {
      className: (0, _utils.ClassNames)('kui-tabs__item', child.props.className ? child.props.className : null, i === active ? 'kui-tabs__item--active' : null),
      ref: i === active ? activeRef : null,
      role: child.props.role || 'tab',
      ['aria-selected']: i === active,
      tabIndex: child.props.tabIndex || (i === active ? 0 : -1),
      ['aria-setsize']: childrenArray.length,
      ['aria-posinset']: i + 1,
      onClick: e => {
        if (onChange) onChange(i);
        if (child.props.onClick) child.props.onClick(e);
      }
    });
  });
  const onKeyDown = e => {
    if (!e) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      if (e.key === 'ArrowRight') {
        focusIndex++;
        if (focusIndex >= buttonHocs.length) {
          focusIndex = 0;
        }
      } else if (e.key === 'ArrowLeft') {
        focusIndex--;
        if (focusIndex < 0) {
          focusIndex = buttonHocs.length - 1;
        }
      }
      const tab = tabsRef.current.querySelector(".kui-tabs__item:nth-child(".concat(focusIndex + 1, ")"));
      if (tab) tab.focus();
    }
  };
  React.useEffect(() => {
    if (activeRef.current) activeRef.current.scrollIntoView({
      inline: 'center',
      behavior: 'smooth'
    });
    setFocusIndex(active);
  }, [active]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    ref: tabsRef,
    role: 'tablist',
    onKeyDown: onKeyDown
  }, attributes), /*#__PURE__*/React.createElement("div", {
    className: "kui-tabs__scroll"
  }, buttonHocs));
});
Tabs.defaultProps = {
  active: 0,
  size: null,
  onChange: () => undefined
};
Tabs.displayName = 'Tabs';